import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import { deleteUserRequest, updateUserRequest } from "store/actions";
import CreateUser from "./CreateUser";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import TableContainer from '../../components/Common/DataTableContainer';
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import UserDataTable from "components/TableContainers/UserDataTable";
import { formatISOToDDMMYYYY } from "helpers/dateFormat_helper";
import Cookies from "js-cookie";


const UserTable = ({ users, loading,totalrows ,roles}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const [selectedSortData, setSelectedSortData] = useState({ value: "createdAt", direction: "desc" });
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState("");
  const user = useSelector(state=>state?.Login.user);
  const permissions  =  JSON.parse(localStorage.getItem('permissions'));
  const hasEditPermission = permissions?.some(item=> item?.permission_name == "Edit User")
  const hasDeletePermission = permissions?.some(item=> item?.permission_name == "Delete User")

  // Handle deletion
  const handleDeleteConfirmed = (id) => {
    dispatch(deleteUserRequest(id));
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDeleteConfirmed(deleteId);
    }
  }, [confirmAction]);
  
    // Table columns
  const columns = useMemo(() => [
{
    header: "Name",
    accessorKey: "name",
    cell: ({ row }) => (
      <div
        style={{
          maxWidth: "250px",
          whiteSpace: "normal",
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordWrap: "break-word",
          lineHeight: "1.4",
          display: "-webkit-box",
          WebkitLineClamp: 2,      // ✅ show 2 lines max
          WebkitBoxOrient: "vertical",
          color: "#222",
          cursor: "pointer"
        }}
        title={row.original.name}  // ✅ show full text on hover
      >
        {row.original.name || "-"}
      </div>
    ),
  },
{
    header: "Email",
    accessorKey: "email",
    cell: ({ row }) => (
      <div
        style={{
          maxWidth: "300px",
          whiteSpace: "normal",
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordWrap: "break-word",
          lineHeight: "1.4",
          display: "-webkit-box",
          WebkitLineClamp: 2,      // ✅ show 2 lines max
          WebkitBoxOrient: "vertical",
          color: "#444",
          cursor: "pointer"
        }}
        title={row.original.email} // ✅ hover shows full email
      >
        {row.original.email || "-"}
      </div>
    ),
  },
    {
      header: "Phone",
      accessorKey: "phone",
      showFilter:false
    },
    {
      header: "Role",
      accessorKey: "role",
      showFilter:false,
      cell:({row})=>(
        <span>{row.original?.role?.role_name}</span>
      )
    },
    {
      header: "Created At",
      accessorKey: "createdAt",
      cell:({row})=>(
        <span>{formatISOToDDMMYYYY(row.original.createdAt)}</span>
      )
    },
    ...(hasEditPermission || hasDeletePermission
      ? [
          {
            header: "Actions",
            id: "actions",
            cell: ({ row }) => {
              const handleEdit = () => {
                console.log("Editing user data ===>", row.original);
                setEditData(row.original);
                setIsOpen(true);
              };
  
              const handleDelete = () => {
                setDeleteId(row.original._id);
                setOpenModal(true);
              };
  
              return (
                <div className="d-flex gap-2">
                  {hasEditPermission && (
                    <Button color="primary" title="Edit" onClick={handleEdit}>
                      <FaRegEdit size={18} />
                    </Button>
                  )}
                  {hasDeletePermission && (
                    <Button color="danger" title="Delete" onClick={handleDelete}>
                      <MdDeleteOutline size={18} />
                    </Button>
                  )}
                </div>
              );
            },
          },
        ]
      : [])
  ], [hasEditPermission, hasDeletePermission]);
  
  const handleFormSubmit = (id,data, onClose) => {
    dispatch(updateUserRequest(id,data, onClose));
  };

  return (
    <>
      {/* Confirmation Modal */}
      <ConfirmationModal
        okText="Confirm"
        onCancel={() => setOpenModal(false)}
        onOk={() => setConfirmAction(true)}
        isVisible={openModal}
        title="Delete User"
        content="Are you sure you want to delete this user?"
      />

      {/* Edit/Create Modal */}
      <CreateUser
        visible={isOpen}
        initialData={editData}
        onSubmit={handleFormSubmit}
        handleClose={() => setIsOpen(false)}
        roles={roles}
      />

      {/* Data Table */}
      <div className="container-fluid">
        <UserDataTable
          columns={columns}
          loading={loading}
          data={users || []}
          isGlobalFilter
          isPagination
          selectedSortData={selectedSortData}
          setSelectedSortData={setSelectedSortData}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
          pageSize={pageSize}
          setSearchString={setSearchString}
          searchString={searchString}
          SearchPlaceholder="Search users..."
          pagination="pagination"
          docName="Users"
          totalrows={totalrows}
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </div>
    </>
  );
};

export default UserTable;
